import DIApi from './_diApi';
import httpClient from '@/apis/base/httpclient';

class DictionaryOptionAPI extends DIApi {
    constructor() {
        super();
    }
    controllerName = 'DictionaryOptions';

    async getDictionaryOptionUser() {
        let apiUrl = this.getAPIUrl();

        let request = {
            url: apiUrl + '/dictionaryOptionUser',
        };

        return await httpClient.getAsync(request);
    }

    async saveHideDictionaryOption(payload) {
        let apiUrl = this.getAPIUrl();

        let request = {
            url: apiUrl + '/dictionaryOptionUser',
            data : payload
        };

        return await httpClient.postAsync(request);
    }
}

export default new DictionaryOptionAPI();